export { ReactComponent as TooltipEdit } from './svgs/tooltip-edit.svg';
